import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { DashboardSummary } from "../../app/generated-axios-client";

interface DashboardState {
  summary: DashboardSummary | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  loadedAt: string | null;
}

const initialState: DashboardState = {
  summary: null,
  status: "idle",
  loadedAt: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    fetchDashboard: (state, _action: PayloadAction<{ project?: string }>) => {
      state.status = "loading";
    },
    storeDashboard: (state, action: PayloadAction<DashboardSummary>) => {
      state.summary = action.payload;
      state.status = "succeeded";
      state.loadedAt = new Date().toISOString();
    },
    setDashboardFailed: (state) => {
      state.status = "failed";
    },
  },
});

export const dashboardActions = dashboardSlice.actions;
export default dashboardSlice.reducer;
